import { useMemo } from "react";

import { addDays, eachDayOfInterval, format } from "date-fns";

import { useReportBodyState } from "./ca-control-state";

export const useDateRangeAsDates = () => {
  const { dateRange } = useReportBodyState();
  const dateLabels: string[] = useMemo(() => {
    return eachDayOfInterval({
      start: addDays(new Date(dateRange.startDate), 1),
      end: addDays(new Date(dateRange.endDate), 1),
    }).map((d) => format(d, "yyyy-MM-dd"));
  }, [dateRange]);
  return dateLabels;
};
